import { BasicText } from "../BasicText/BasicText";

/* eslint-disable react/prop-types */

// LEGACY SHIM — the separate "Rich Text" element was removed from the product:
// the single text element (BasicText, now displayed as "Rich Text") covers
// rich editing via the inline editor + the right rail's full CKEditor. This
// alias keeps previously-saved trainings with RichText boxes loading and
// behaving EXACTLY like a normal text box; only the plugin name (the stored
// id) and icon differ. Not listed in the components panel.
export function RichText(base) {
  const impl = BasicText(base);
  const baseGetConfig = impl.getConfig;
  return {
    ...impl,
    getConfig: function () {
      return {
        ...baseGetConfig.call(this),
        name: "RichText",
        displayName: IdealStudio.i18n.t("BasicText.PluginName"),
        icon: "format_indent_increase",
      };
    },
  };
}
/* eslint-enable react/prop-types */
